<template>
    <div :class="$style.wrapper">
        <Installation-Company></Installation-Company>
    </div>
</template>

<script>
    import Vue from 'vue';
    import InstallationCompany from '../components/InstallationCompany';

    Vue.component('Installation-Company', InstallationCompany.CompanyList);
    export default {
        data () {
            return {};
        }
    };
</script>

<style lang="less" module>
    .wrapper {

    }
</style>



// WEBPACK FOOTER //
// src/router/InstallationCompany.vue